export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <g transform="scale(10.666667)">
    <path
      d="M16.3808 17.4618C16.3808 18.0145 16.3808 18.2909 16.2 18.4279C16.0193 18.5649 15.7532 18.4902 15.221 18.3409L6.66908 15.9411C6.34845 15.8512 6.1881 15.8062 6.0954 15.6839C6.00271 15.5616 6.00271 15.395 6.00271 15.062V9.43797C6.00271 9.10496 6.00271 8.93844 6.0954 8.81613C6.1881 8.69383 6.34845 8.64883 6.66908 8.55887L15.221 6.15906C15.7532 6.00975 16.0193 5.93508 16.2 6.07209C16.3808 6.2091 16.3808 6.48547 16.3808 7.0382V17.4618ZM8.13552 15.1587L15.2165 17.146V13.1717L8.13552 15.1587ZM7.16685 14.2368L14.2465 12.25L7.16685 10.2632V14.2368ZM8.13544 9.34129L15.2165 11.3284V7.35402L8.13544 9.34129Z"
      fill={fill}
    />
  </g>
);
